/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NftStatus_enum = "Auction" | "Listed" | "Owned" | "%future added value";
export type NftOtherInfo_MetadataAccount = {
    readonly id: string;
    readonly nft: {
        readonly id: string;
        readonly isOffPlatform: boolean;
        readonly price: unknown | null;
        readonly status: NftStatus_enum;
    };
    readonly " $refType": "NftOtherInfo_MetadataAccount";
};
export type NftOtherInfo_MetadataAccount$data = NftOtherInfo_MetadataAccount;
export type NftOtherInfo_MetadataAccount$key = {
    readonly " $data"?: NftOtherInfo_MetadataAccount$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"NftOtherInfo_MetadataAccount">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftOtherInfo_MetadataAccount",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftExpress",
      "kind": "LinkedField",
      "name": "nft",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOffPlatform",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MetadataAccount",
  "abstractKey": null
};
})();
(node as any).hash = '9fbda50562ff755140c534dbd70e1f55';
export default node;
